export default __webpack_public_path__ + "static/media/swachBharatlogo.00b66da5.png";